module.exports = __webpack_public_path__ + "static/media/discussion.a8ba2357.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/discussion.jpg
// module id = 528
// module chunks = 0